<mf-page title="Transferencias">
  <mf-row>
    <mf-transfer-grid [showCreateButton]="true" />
  </mf-row>
</mf-page>
